module.exports = __webpack_public_path__ + "static/0cee929c.tipmodal01.png";